import { FEATURES } from '@/src/constants/Text'

export const OVERVIEW_EVENTS = {
  APPLY_FRAMING: 'consolidator_overview_apply_framing',
}

export const CONSOLIDATOR_TABLE_CUSTOM_SORT_FIELDS = {
  texts: ['operacao', 'nome_ativo', 'tipo', 'origem'],
  numbers: ['quantidade', 'valor_unitario', 'valor', 'valor_total', 'pu'],
  dates: [
    'data',
    'data_cotizacao',
    'date',
    'data_com',
    'data_pagamento',
    'data_registro',
  ],
}

export const TABLE_PER_PAGE_OPTIONS = [10, 25, 50, 100, -1]

export const ICONES_EVENTS = {
  Inicial: {
    name: 'mdi-minus',
    color: 'grey darken-1',
    iconColor: 'white',
  },
  Resgate: {
    name: 'send-skinny-down',
    color: '#EB57574D',
    iconColor: '#BC4E4E',
  },
  'Resgate total': {
    name: 'send-skinny-down',
    color: '#EB57574D',
    iconColor: '#BC4E4E',
  },
  'Resgate Total': {
    name: 'send-skinny-down',
    color: '#EB57574D',
    iconColor: '#BC4E4E',
  },
  Aplicação: {
    name: 'send-skinny-up',
    color: '#56AF794D',
    iconColor: '#368B57',
  },
  Proventos: {
    name: 'mdi-currency-usd',
    color: 'info',
  },
  Desdobramento: {
    name: 'mdi-percent',
    color: 'yellow darken-3',
  },
  Agrupamento: {
    name: 'mdi-percent',
    color: 'yellow darken-3',
  },
  Cupom: {
    name: 'mdi-label-percent-outline',
    color: 'green darken-3',
  },
  Amortização: {
    name: 'mdi-hand-coin-outline',
    color: 'green darken-3',
  },
  Vencimento: {
    name: 'mdi-calendar-outline',
    color: 'secondary',
  },
  'Bonificação (%)': {
    name: 'mdi-percent-circle-outline',
    color: 'amber lighten-1',
  },
  'Bonificação (fracionário)': {
    name: 'mdi-percent-circle-outline',
    color: 'amber lighten-1',
  },
  default: {
    name: 'mdi-calendar-blank-outline',
    color: 'secondary',
  },
}
export const WALLET_EMPTY_MESSAGE = 'Sem dados para exibir no momento'

export const consolidadorOptionsRoutes = (currentUser, showFeatures) => {
  const shouldShowOverview =
    showFeatures[FEATURES.CONSOLIDATOR_OVERVIEW] && !currentUser.IS_CLIENTE
  const shouldShowVencimentos =
    showFeatures[FEATURES.MANAGE_REDEMPTION] && !currentUser.IS_CLIENTE
  const shouldShowSettings = !currentUser.IS_GESTOR && !currentUser.IS_CLIENTE
  // Oculta a submenu "IPS" de Carteiras quando OCULTAR_CROSS_SELL=TRUE.
  const hideCrossSell = !!showFeatures[FEATURES.OCULTAR_CROSS_SELL]
  const carteiraChildren = [
    'carteira.minha',
    'carteira.minha.cliente',
    'carteira.movimentacoes',
    'carteira.extrato_caixa',
    ...(hideCrossSell ? [] : ['carteira.ips']),
    'carteira.analise',
    'carteira.gestao_risco',
    'carteira.liquidity',
    'carteira.evolucao',
    'carteira.sugestoes',
  ]
  const options = [
    {
      name: 'carteira.overview',
      title: 'Visão Geral',
      hasAccess: shouldShowOverview,
    },
    {
      name: 'carteira.group',
      title: 'Carteiras',
      hasAccess: true,
      children: carteiraChildren,
    },
    {
      name: 'carteira.vencimentos',
      title: 'Gerenciamento de Vencimentos',
      hasAccess: shouldShowVencimentos,
    },
    {
      name: 'carteira.configuracoes',
      title: 'Configurações',
      hasAccess: shouldShowSettings,
      children: [
        'carteira.configuracoes.home',
        'carteira.configuracoes.portfolio-modelo',
      ],
    },
    {
      name: 'carteira.back_office',
      title: 'Back Office',
      hasAccess: showFeatures[FEATURES.BACK_OFFICE] && !currentUser.IS_CLIENTE,
    },
  ]

  return options.filter((opt) => opt.hasAccess)
}

export const carteiraRoutes = () => [
  { name: 'carteira.minha', title: 'Carteira atual' },
  { name: 'carteira.movimentacoes', title: 'Extrato' },
  { name: 'carteira.evolucao', title: 'Evolução patrimonial' },
  { name: 'carteira.ips', title: 'IPS' },
  { name: 'carteira.analise', title: 'Análise portfólio' },
  { name: 'carteira.gestao_risco', title: 'Análise de risco' },
  { name: 'carteira.liquidity', title: 'Liquidez' },
  { name: 'carteira.atualizacoes', title: 'Contas de investimento' },
  { name: 'carteira.integrationLogs', title: 'Logs de Integração' },
  { name: 'carteira.atividades', title: 'Histórico de atividades' },
  { name: 'carteira.financeiro', title: 'Financeiro' },
]

// Rótulos dos campos que a IA propõe, por entidade. Servem para o card DIZER o que muda em
// português, em vez de exibir a chave crua do banco (`valor_unitario`, `subtipo`).
export const CAMPOS_DO_ATIVO = {
  classe: 'Classe',
  subtipo: 'Subclasse',
  tipo: 'Tipo',
  emissor: 'Emissor',
  taxa: 'Taxa',
  data_vencimento: 'Vencimento',
  referencia: 'Referência',
  isin: 'ISIN',
}

export const CAMPOS_DA_MOVIMENTACAO = {
  valor_unitario: 'Preço unitário',
  quantidade: 'Quantidade',
  valor: 'Valor',
}

export const CONTEXTO_DO_ATIVO = 'Cadastro do ativo'

export const SUGESTOES_IA_VIEW = {
  kpiPendentes: 'Pendentes',
  kpiPendentesDesc: 'Sugestões aguardando sua curadoria',
  kpiAtivos: 'Ativos citados',
  kpiAtivosDesc: 'Ativos com ao menos uma sugestão pendente',
  kpiAprovadas: 'Aprovadas',
  kpiAprovadasDesc: 'Sugestões que viraram registro',
  kpiRecusadas: 'Recusadas',
  kpiRecusadasDesc: 'Sugestões descartadas na curadoria',
  abaPendentes: (n) => `Pendentes (${n})`,
  abaAprovadas: (n) => `Aprovadas (${n})`,
  abaRecusadas: (n) => `Recusadas (${n})`,
  vazioTitulo: 'Nada a revisar',
  vazioDescricao:
    'Quando a IA propuser um ajuste em algum ativo das carteiras, ele aparece aqui.',
  erroTitulo: 'Não foi possível carregar as sugestões',
  erroDescricao: 'A fila da IA não respondeu.',
  tentarNovamente: 'Tentar novamente',
  semAcessoTitulo: 'Tela exclusiva do profissional',
  semAcessoDescricao:
    'A curadoria das sugestões da IA é feita pelo seu assessor.',
  ativoSalvoSugestaoPendente:
    'O ativo foi salvo, mas a sugestão continuou pendente. Abra Sugestões da IA e aprove ou recuse para tirá-la da fila.',
  sugestaoSemTexto: 'A IA não registrou o motivo desta sugestão.',
  movimentacaoNaoEncontrada:
    'Não foi possível abrir a movimentação desta sugestão: ela não está na lista do cliente. Recarregue a página e tente de novo.',
  semClienteNoAtivo:
    'Não foi possível abrir as sugestões: este ativo está sem cliente vinculado. Vincule o ativo a um cliente e tente de novo.',
  carteiraCarregando:
    'A carteira ainda está carregando. Assim que os ativos aparecerem, o painel abre com o nome de cada um.',
  movimentacaoSalvaSugestaoPendente:
    'A movimentação foi salva, mas a sugestão continuou pendente. Abra Sugestões da IA e aprove ou recuse para tirá-la da fila.',
  edicaoNaoAbriu:
    'Não foi possível abrir a edição desta sugestão: o registro que ela aponta não está na lista carregada. Recarregue a página.',
  precoSugeridoAplicado:
    'Preço unitário atualizado para o valor sugerido. Confira os dados e clique em Salvar para gravar.',
}

export const ASSET_TAGS = {
  legendaSugestoes: 'Sugestões da IA pendentes',
}
export const ALOCACAO_VAZIOS = {
  COM_VALOR: 'com-valor',
  TODAS: 'todas',
}

export const ALOCACAO_VISAO = {
  ALOCACAO: 'alocacao',
  SUGERIDO: 'sugerido',
}

export const ALOCACAO_VAZIOS_OPTIONS = [
  { value: ALOCACAO_VAZIOS.COM_VALOR, text: 'Com valor' },
  { value: ALOCACAO_VAZIOS.TODAS, text: 'Todas' },
]

export const ALOCACAO_VISAO_OPTIONS = [
  { value: ALOCACAO_VISAO.ALOCACAO, text: 'Alocação' },
  { value: ALOCACAO_VISAO.SUGERIDO, text: 'Sugerido' },
]
